const positionFill = {
  position: 'absolute',
  left: 0,
  top: 0,
  right: 0,
  bottom: 0,
};

export const getCellOverlayStyle = () => ({
  cellOverlayContainer: {
    ...positionFill,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    background: 'linear-gradient(180deg, rgba(49, 34, 34, 0.3) 0%, rgba(49, 34, 34, 0.8) 53.12%, #312222 100%)',
    opacity: 0,
    transition: 'opacity 0.2s ease-out',
    borderRadius: 6,
  },
});
